'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PopoverTick = require('./PopoverTick');

var _PopoverTick2 = _interopRequireDefault(_PopoverTick);

var _PopoverCloseButton = require('./PopoverCloseButton');

var _PopoverCloseButton2 = _interopRequireDefault(_PopoverCloseButton);

var _PopoverTitle = require('./PopoverTitle');

var _PopoverTitle2 = _interopRequireDefault(_PopoverTitle);

var _OutsideAlerter = require('../OutsideAlerter');

var _OutsideAlerter2 = _interopRequireDefault(_OutsideAlerter);

var _screenService = require('../../../services/screenService');

var _screenService2 = _interopRequireDefault(_screenService);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_WIDTH = 480;
var PADDING = 20;

var Popover = function (_Component) {
  _inherits(Popover, _Component);

  function Popover() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.calculateLeftPosition = function () {
      var parent = _this.props.parentNode.getBoundingClientRect();

      var windowWidth = _screenService2.default.width;
      var popoverWidth = Math.min(MAX_WIDTH, windowWidth - PADDING * 2);

      // This is the naive placement of the popover on the *page*.
      // The distance from the left side of the page to the left side of the popover
      var pageX = parent.x + (parent.width - popoverWidth) / 2;

      // Min distance from the left of the page until our popover overflows left.
      var minPageX = PADDING;
      // Max distance from the left of the page until our popover overflows right.
      var maxPageX = windowWidth - PADDING - popoverWidth;

      // Here we clamp the values between our min and our max to prevent overflow.
      pageX = (0, _lodash.clamp)(pageX, minPageX, maxPageX);

      // Now we translate our distance in "page" coordinates so that it is relative
      // to the parent element (which is what our CSS wants).
      return pageX - parent.x;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popover, [{
    key: 'render',
    value: function render() {
      var isOpen = this.props.isOpen;

      if (!isOpen) return null;

      var className = 'Popover ' + this.props.className;
      var props = {
        className: className
      };

      if (!_screenService2.default.isMobile() && !_screenService2.default.isTabletSmall()) {
        props.style = { left: this.calculateLeftPosition() };
      }
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          props,
          this.props.children
        ),
        _react2.default.createElement(_PopoverTick2.default, null)
      );
    }
  }]);

  return Popover;
}(_react.Component);

Popover.Title = _PopoverTitle2.default;
exports.default = Popover;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/Popover/index.js
// module id = 588
// module chunks = 0